import { Component } from '@angular/core'
import { ApiserviceService } from './Utilites/services/api/apiservice.service'
import { AuthenticationService } from './Components/Authentication/Services/authentication.service'
import { Router } from '@angular/router'

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  isCollapsed = false

  user: any | undefined

  constructor(
    // private router: Router,
    private authenticationService: AuthenticationService,
    private apiservice: ApiserviceService
  ) {
    this.apiservice.getaddresstoken()

    if (this.authenticationService.user) {
      this.authenticationService.user.subscribe((x) => {
        this.user = x
      })
    }
  }
  ngAfterContentChecked() {
    if (this.authenticationService.user) {
      this.authenticationService.user.subscribe((x) => (this.user = x))
    }
  }
}
